<template>
  <div class="minimalistSolution">
    <div class="minimalist-top">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <div class="minimalist-top-content">
            <div class="minimalist-top-content-left">
              <img :src="content[num].image" width="100%"/>
            </div>
            <div class="minimalist-top-content-right">
              <h2>{{content[num].title1}}</h2>
             <p>{{content[num].wordP1}}</p>
              <p>{{content[num].wordP2}}</p>
            </div>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>
    <div class="minimalist-cent">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <h3>解决的核心问题</h3>
          <div class="minimalist-cent-content">
            <div class="coreIssue-content" v-for="item of content[num].coreIssue" :key="item.goodsId">
              <div class="coreIssue">
                <img src="../../assets/img/56.png" width="20%"/>
                <p>{{item.content1}}</p>
                <span>{{item.content2}}</span>
              </div>
            </div>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>
    <div class="minimalist-bottom">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <h3>方案概述</h3>
          <p>{{content[num].title2}}</p>
          <div class="minimalist-bottom-content">
            <div class="program-overview-content" v-for="item of content[num].programOverview" :key="item.goodsId">
              <div class="program-overview1">
                <div class="program-overview-img">
                  <img src="../../assets/img/57.png" width="100%">
                </div>
                <div class="program-overview-word">
                  <p>{{item.title1}}</p>
                  <span>{{item.content1}}</span>
                </div>
              </div>
              <div class="program-overview2">
                <div class="program-overview-img">
                  <img src="../../assets/img/57.png" width="100%">
                </div>
                <div class="program-overview-word">
                  <p>{{item.title2}}</p>
                  <span>{{item.content2}}</span>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        num:this.$route.query.num,
        content:{
          "0":{
            title1:"极简以太全光解决方案",
            wordP1:"适用于高教，普教，企业，医疗等应用领域",
            wordP2:"",
            image:require("../../assets/img/solution-content1.png"),
            coreIssue:[
              {
                goodsId:0,
                content1:"Question ONE",
                content2:"业务终端越来越多,网络扩展复杂,设备替换复杂"
              },
              {
                goodsId:1,
                content1:"Question TWO",
                content2:"业务对带宽要求越来越高"
              },
              {
                goodsId:2,
                content1:"Question Three",
                content2:"安全管控多网融合,设备激增,专业人手不足"
              }
            ],
            title2:"基础网络建设采用以无源光网络+以太网交换机为核心技术的“以太全光”组网方案，整体方案逻辑架构采用扁平化设计:",
            programOverview:[
              {
                goodsId:0,
                title1:"Article 1",
                content1:"基础网络，整体组网结构如下，主要解决房间信息接入",
                title2:"Article 2",
                content2:"新建双核心交换机，为整个网络提供统一交换功能"
              },
              {
                goodsId:1,
                title1:"Article 3",
                content1:"通过全光交换机进行汇聚",
                title2:"Article 4",
                content2:"在每个区域内（房间内）放置4/8/16口接入交换机，提供设备接入"
              }
            ]
          },
          "1":{
            title1:"本地化物联网平台解决方案",
            wordP1:"适用于园区、工厂、大型社区、高校、大型商业体和大型企事业单位等",
            wordP2:"需要本地化统一管理物联设备的场景",
            image:require("../../assets/img/bdhwlw.png"),
            coreIssue:[
              {
                goodsId:0,
                content1:"Question ONE",
                content2:"应用系统依赖物联设备厂家众多，协议多样"
              },
              {
                goodsId:1,
                content1:"Question TWO",
                content2:"集中管理难，统一维护难"
              },
              {
                goodsId:2,
                content1:"Question Three",
                content2:"第3方系统集成难"
              }
            ],
            title2:"以我司物联网关、物联网管理平台和物联设备供应生态圈为基础，提供本地化物联网综合管理解决方案，辅助客户解决:",
            programOverview:[
              {
                goodsId:0,
                title1:"Article 1",
                content1:"物联设备、物联网关便捷接入及统一管理",
                title2:"Article 2",
                content2:"标准化物联设备运行状态监测及指令遥控接口"
              },
              {
                goodsId:1,
                title1:"Article 3",
                content1:"统一管理物联设备应用权限",
                title2:"Article 4",
                content2:"标准化物联设备或物联网络运维保障流程"
              }
            ]
          },
          "2":{
            title1:"智慧园区解决方案",
            wordP1:"适用于各类型园区智慧化综合管理场景",
            wordP2:"",
            image:require("../../assets/img/zh.png"),
            coreIssue:[
              {
                goodsId:0,
                content1:"Question ONE",
                content2:"技术标准不统一，集成难，统一管理难"
              },
              {
                goodsId:1,
                content1:"Question TWO",
                content2:"各系统边界壁垒多，对接难"
              },
              {
                goodsId:2,
                content1:"Question Three",
                content2:"上层横向智慧应用建设难"
              }
            ],
            title2:"以我司物联网管理平台、应用集成平台和数据中台为基础，提供智慧园区解决方案，辅助客户:",
            programOverview:[
              {
                goodsId:0,
                title1:"Article 1",
                content1:"统一管理设备、各应用系统",
                title2:"Article 2",
                content2:"建设数据中心，集中统一管理全量数据"
              },
              {
                goodsId:1,
                title1:"Article 3",
                content1:"对接各设备及应用系统，统一管理各设备、应用系统对外服务接口和数据共享接口",
                title2:"Article 4",
                content2:"建设资源综合管理、基础管理平台、智慧通行、消安一体化和一卡（码/机/脸）通等应用系统"
              }
            ]
          },
          "3":{
            title1:"信息安全生态解决方案",
            wordP1:"适用于所有政企单位对网络安全有一定要求的的场景",
            wordP2:"",
            image:require("../../assets/img/solution-content4.png"),
            coreIssue:[
              {
                goodsId:0,
                content1:"Question ONE",
                content2:"核心服务存在病毒入侵问题"
              },
              {
                goodsId:1,
                content1:"Question TWO",
                content2:"企事业单位终端存在安全漏洞问题"
              },
              {
                goodsId:2,
                content1:"Question Three",
                content2:"网络、虚拟化安全管理难问题"
              }
            ],
            title2:"结合客户实际，为客户提供全方位的信息安全生态解决方案:",
            programOverview:[
              {
                goodsId:0,
                title1:"Article 1",
                content1:" 以奇安信安全接入网关、防火墙",
                title2:"Article 2",
                content2:"终端安全管理、虚拟化安全管理"
              },
              {
                goodsId:1,
                title1:"Article 3",
                content1:"上网行为管理",
                title2:"Article 4",
                content2:"威胁感知系统产品"
              }
            ]
          },
		  "4":{
		    title1:"锐捷三擎云桌面解决方案",
		    wordP1:"适用于教学场景：公共教学，专业实训室，多媒体教学；办公场景：办公、生产、公共、分支",
		    wordP2:"",
		    image:require("../../assets/img/solution-content4.png"),
		    coreIssue:[
		      {
		        goodsId:0,
		        content1:"Question ONE",
		        content2:"单一云桌面技术无法满足"
		      },
		      {
		        goodsId:1,
		        content1:"Question TWO",
		        content2:"新的业务平台，工作量大，周期长"
		      },
		      {
		        goodsId:2,
		        content1:"Question Three",
		        content2:"无法一步到位实现全面替代，PC与云桌面长期共存"
		      }
		    ],
		    title2:"锐捷三擎云桌面解决方案的核心思想是通过统一的云桌面管理平台，面向中小学不同的教学、办公场景特点，提供差异化的技术方案",
		    programOverview:[
		      {
		        goodsId:0,
		        title1:"Article 1",
		        content1:"统一的云桌面管理平台",
		        title2:"Article 2",
		        content2:"配套提供与教学、办公、管理相关的应用"
		      },
		      {
		        goodsId:1,
		        title1:"Article 3",
		        content1:"提供直接的应用服务",
		        title2:"Article 4",
		        content2:"平台级解决方案"
		      }
		    ]
		  },
		  "5":{
		    title1:"锐捷轻云解决方案",
		    wordP1:"适用于小型企业、村小县小、教育局集采、分支办公",
		    wordP2:"",
		    image:require("../../assets/img/solution-content4.png"),
		    coreIssue:[
		      {
		        goodsId:0,
		        content1:"Question ONE",
		        content2:"电脑经常中毒或出故障，不会解决"
		      },
		      {
		        goodsId:1,
		        content1:"Question TWO",
		        content2:"电脑长时间使用，系统变得臃肿缓慢"
		      },
		      {
		        goodsId:2,
		        content1:"Question Three",
		        content2:"小型机构的技术能力不强，终端维护依赖代理商"
		      }
		    ],
		    title2:"轻量级云桌面架构无需购买服务器，真正的云端管理",
		    programOverview:[
		      {
		        goodsId:0,
		        title1:"Article 1",
		        content1:"轻量级终端设计",
		        title2:"Article 2",
		        content2:"终端上线快"
		      },
		      {
		        goodsId:1,
		        title1:"Article 3",
		        content1:"故障恢复快",
		        title2:"Article 4",
		        content2:"远程维护快"
		      }
		    ]
		  },
			"6":{
			  title1:'政务一体化安全解决方案',
			  wordP1:"适用于政府机构；",
			  wordP2:"",
			  image:require("../../assets/img/solution-content4.png"),
			  coreIssue:[
			    {
			      goodsId:0,
			      content1:"Question ONE",
			      content2:"解决群众反映强烈的办事难、办事慢、办事繁"
			    },
			    {
			      goodsId:1,
			      content1:"Question TWO",
			      content2:"强化风险应对（监测、预警、处置、溯源等）能力"
			    },
			    {
			      goodsId:2,
			      content1:"Question Three",
			      content2:"实现对全网安全状况的统一管理"
			    }
			  ],
			  title2:"“互联网+放管服”政务一体化系统达到国家网络安全等级保护三级要求。",
			  programOverview:[
			    {
			      goodsId:0,
			      title1:"Article 1",
			      content1:"提升信息系统安全防护水平",
			      title2:"Article 2",
			      content2:"不断提升政府治理能力，让治理更有效，让人民更有获得感"
			    },
			    {
			      goodsId:1,
			      title1:"Article 3",
			      content1:"促进政务公开，提高政府监管能力和服务水平",
			      title2:"Article 4",
			      content2:"采用新的信息安全保护技术，按照体系化的信息安全防护策略进行整体规划"
			    }
			  ]
			},
			"7":{
			  title1:"等级保护2.0解决方案",
			  wordP1:"可广泛运用于政府机构、各类企业和组织等",
			  wordP2:"",
			  image:require("../../assets/img/solution-content4.png"),
			  coreIssue:[
			    {
			      goodsId:0,
			      content1:"Question ONE",
			      content2:"全球网络安全形势严峻"
			    },
			    {
			      goodsId:1,
			      content1:"Question TWO",
			      content2:"网络安全面临着各种新的挑战"
			    },
			    {
			      goodsId:2,
			      content1:"Question Three",
			      content2:"《网络安全法》进一步明确了信息化发展与网络安全"
			    }
			  ],
			  title2:"随着云计算、大数据、移动办公、物联网、工业控制等技术的发展，新的IT技术和应用极大地改变了网络安全的外延和内涵，同时，在新技术环境下，新型网络安全攻击技术和手段层出不穷，改变了我们以往对信息安全威胁和风险的认知。",
			  programOverview:[
			    {
			      goodsId:0,
			      title1:"Article 1",
			      content1:"以“一个中心、三重防护”要求为基础，构建满足等级保护2.0要求的技术能力",
			      title2:"Article 2",
			      content2:"以体系化设计思路，按照基础架构安全、动态身份安全、纵深防御体系、全生命周期防护等实际安全需求，进行安全技术体系规划设计"
			    },
			    {
			      goodsId:1,
			      title1:"Article 3",
			      content1:"以自适应的安全架构为目标，构建持续改进的安全运营体系，在安全运营过程中实现安全技术体系的持续优化完善",
			      title2:"Article 4",
			      content2:"以安全管理体系的落地实践为导向，提升安全运营能力，更好地落实等级保护制度"
			    }
			  ]
			},
			"8":{
			  title1:"智慧校园解决方案",
			  wordP1:"普教、高教、职教校园智慧化解决方案",
			  wordP2:"",
			  image:require("../../assets/img/solution-content4.png"),
			  coreIssue:[
			    {
			      goodsId:0,
			      content1:"Question ONE",
			      content2:"校园安全问题"
			    },
			    {
			      goodsId:1,
			      content1:"Question TWO",
			      content2:"教学教务问题"
			    },
			    {
			      goodsId:2,
			      content1:"Question Three",
			      content2:"校园生活问题"
			    }
			  ],
			  title2:"智慧校园是对数字校园的进一步扩展与提升，释放先进技术优势和管理的智慧，为师生提供以人为本、智能开放的创新服务。",
			  programOverview:[
			    {
			      goodsId:0,
			      title1:"Article 1",
			      content1:"定制化的应用服务：校园安全管理、教学教务管理、校园生活服务、校园动态管理、家校管理、校园后勤管理",
			      title2:"Article 2",
			      content2:"天鸿在线中台产品：天鸿在线数据中台产品，可实现全量采集数据，资产化管理数据，定制化开发数据应用的大数据管理平台"
			    },
			    {
			      goodsId:1,
			      title1:"Article 3",
			      content1:"依托智能建设设计标准，建设基于校园的智能基础设施为上层提供基础数据支持",
			      title2:"Article 4",
			      content2:"提供一种环境全面感知、智慧型、数据化、网络化、协作型一体化的教学、科研、管理和生活服务"
			    }
			  ]
			},
			"9":{
			  title1:"智慧医疗解决方案",
			  wordP1:"以单体医疗机构为主体的智慧医疗解决方案",
			  wordP2:"",
			  image:require("../../assets/img/solution-content4.png"),
			  coreIssue:[
			    {
			      goodsId:0,
			      content1:"Question ONE",
			      content2:"无法提供基于医疗机构内的全面感知和数据采集"
			    },
			    {
			      goodsId:1,
			      content1:"Question TWO",
			      content2:"医疗成本高、渠道少、覆盖面低"
			    },
			    {
			      goodsId:2,
			      content1:"Question Three",
			      content2:"区域卫生信息化医疗数据，难于实现统一管理"
			    }
			  ],
			  title2:"智慧医疗是一套融合物联网、云计算等技术，以患者数据为中心的医疗服务模式，采用传感器、物联网、云计算、通信等技术结合现代医学理念。",
			  programOverview:[
			    {
			      goodsId:0,
			      title1:"Article 1",
			      content1:"以患者为中心：提升医疗服务质量，改善医患关系，提高运行效率。",
			      title2:"Article 2",
			      content2:"全面智能化：运营、医疗、财务、行政、后勤、科教、决策、区域。"
			    },
			    {
			      goodsId:1,
			      title1:"Article 3",
			      content1:"组织关系改造与业务流程优化：流程、组织、质量、成本、绩效。",
			      title2:"Article 4",
			      content2:"数据中台：将医疗服务对象、手段、过程、管理等数字化，而且能够实现医疗信息资源的交换、共享，实现服务的互联互通，同时实现智能化的技术创新"
			    }
			  ]
			},
			"10":{
			  title1:"智慧社区解决方案",
			  wordP1:"以居住小区、社区管理者及配套设施主体的智慧社区解决方案",
			  wordP2:"",
			  image:require("../../assets/img/solution-content4.png"),
			  coreIssue:[
			    {
			      goodsId:0,
			      content1:"Question ONE",
			      content2:"当前社区管理与服务已经滞后于群众的需求"
			    },
			    {
			      goodsId:1,
			      content1:"Question TWO",
			      content2:"医疗成本高、渠道少、覆盖面低"
			    },
			    {
			      goodsId:2,
			      content1:"Question Three",
			      content2:"居民对社区的归属感和认同感的不足"
			    }
			  ],
			  title2:"智慧社区是社区管理的一种新理念，是新形势下社会管理创新的一种新模式。",
			  programOverview:[
			    {
			      goodsId:0,
			      title1:"Article 1",
			      content1:"社区物业服务：物业形象展示、物业通知、物业报修、业主心声、业主评价、社区文化活动等功能。",
			      title2:"Article 2",
			      content2:"社区政务服务：提供与民生息息相关的政策查询、发布及宣传各类重大通知公告、民意调查与民意反馈处理、居委会、业委会等社区自治在线办公、居民政府事务的在线预约和办理。"
			    },
			    {
			      goodsId:1,
			      title1:"Article 3",
			      content1:"社区生活服务：完整的社区服务生态体系，打造基于居家便捷生活的社区服务标准，严审商家资质、严管商家行为、严控服务质量，让居民足不出户，享受优越、舒适的便利生活，包含了家政服务，保洁服务，会所预订，订餐服务，网上超市购物。",
			      title2:"Article 4",
			      content2:"社区便民服务：从居民日常生活中实际需要出发。内容包罗万象，服务本地居民，做居民的生活好向导、好帮手公交线路查询、常用电话号码查询、列车时刻表查询、水费查询、电费查询、燃气查询、供暖查询、物业费用查询智慧社区中台。"
			    }
			  ]
			},
			"11":{
			  title1:"智慧景区解决方案",
			  wordP1:"风景名胜、风俗村、历史文化名城等景区智慧化解决方案",
			  wordP2:"",
			  image:require("../../assets/img/solution-content4.png"),
			  coreIssue:[
			    {
			      goodsId:0,
			      content1:"Question ONE",
			      content2:"当前景区各个景点资源难以整合"
			    },
			    {
			      goodsId:1,
			      content1:"Question TWO",
			      content2:"管理部门之间缺乏一套统一的的业务系统"
			    },
			    {
			      goodsId:2,
			      content1:"Question Three",
			      content2:"景区与游客不能建立紧密关联"
			    }
			  ],
			  title2:"利用云计算、物联网等新技术，通过互联网/移动互联网，借助便携的终端上网设备，主动感知旅游资源、旅游经济、旅游活动、旅游者等方面的信息",
			  programOverview:[
			    {
			      goodsId:0,
			      title1:"Article 1",
			      content1:"面向商家：库存管理；智能优惠券；广告营销；资讯发布。",
			      title2:"Article 2",
			      content2:"面向景区实现景区综合安防；电子门票及优惠；资讯发布；广告营销；游客流量统计/分析/挖掘/管理；车辆管理；景区道路管理；旅游电子商务。"
			    },
			    {
			      goodsId:1,
			      title1:"Article 3",
			      content1:"面向游客：景点介绍；电子门票及优惠；智能导游；旅游线路规划；资讯发布；电子解说；互动社交服务；旅游电子商务；呼叫中心；报警救助。",
			      title2:"Article 4",
			      content2:"面向政府：景区综合安防；资讯发布；业务统计分析；客流量统计/分析/挖掘/管理。"
			    }
			  ]
			}
        }
      }
    }
  }

</script>

<style lang="less">
  .minimalistSolution{
    .minimalist-top{
      background-size: 100% 100%;
      background-image: url(../../assets/img/minimalistSolutionBj.jpg);
      background-repeat: no-repeat;
      padding-top: 1rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      .minimalist-top-content{
        display: flex;

        .minimalist-top-content-left{
          flex: 1.4;
        }
        .minimalist-top-content-right{
          flex: 3;
          text-align: right;
          padding-right: 0.1rem;
          color: #FFFFFF;
          p{
             font-family: MicrosoftYaHeiLight;
             font-size: 12px;
             font-weight: normal;
             font-stretch: normal;
             line-height: 33px;
             letter-spacing: 0px;
             color: #ffffff;
          }
          h2{
            margin-top: 1rem;
            margin-bottom: 0.3rem;
            font-family: SourceHanSansCN-Medium;
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0px;
            letter-spacing: 0px;
            color: #ffffff;
          }
        }
      }
    }
    .minimalist-cent{
      background-size: 100% 100%;
      background-image: url(../../assets/img/core-issue-bj.jpg);
      background-repeat: no-repeat;
      padding-top: 1rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      text-align: center;
      h3{
         font-family: SourceHanSansCN-Regular;
         font-size: 24px;
         font-weight: bold;
         font-stretch: normal;
         line-height: 0px;
         letter-spacing: 0px;
         color: #333333;
        margin-bottom: 0.5rem;
      }
      .minimalist-cent-content{
        display: flex;
        margin-bottom: 1rem;
        .coreIssue-content{
          flex: 1;
          padding-bottom: 0.5rem;
          // border-right:1px solid #000;
          .coreIssue{
            img{
              margin-top: 0.5rem;
            }
            p{
              margin-top: 0.3rem;
              margin-bottom: 0.3rem;
               font-family: SourceHanSansCN-Regular;
               font-size: 18px;
               font-weight: normal;
               font-stretch: normal;
               line-height: 55px;
               letter-spacing: 0px;
               color: #253954;
            }
            span{
               font-family: SourceHanSansCN-Light;
               font-size: 12px;
               font-weight: normal;
               font-stretch: normal;
               line-height: 44px;
               letter-spacing: 0px;
               color: #253954;
            }
          }
        }
      }
    }
    .minimalist-bottom{
      background-image: linear-gradient(#f4f5fa, #fdfdfd);
      text-align: center;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      h3{
        margin-top: 1rem;
        margin-bottom: 0.3rem;
         font-family: SourceHanSansCN-Regular;
         font-size: 24px;
         font-weight: bold;
         font-stretch: normal;
         line-height: 0px;
         letter-spacing: 0px;
         color: #333333;
      }
      p{
        margin-bottom: 0.3rem;
         font-family: SourceHanSansCN-Light;
         font-size: 11px;
         font-weight: normal;
         font-stretch: normal;
         line-height: 55px;
         letter-spacing: 0px;
         color: #253554;
      }
      .minimalist-bottom-content{
        .program-overview-content{
          display: flex;
          text-align: left;
          .program-overview1{
            flex: 1;
            display: flex;
            box-shadow: 0 0 5px #eaeff5 inset;
            margin-right: 0.5rem;
            padding: 0.3rem;
            margin-bottom: 0.3rem;
            .program-overview-img{
              flex: 1;
              padding-top: 0.3rem;
            }
            .program-overview-word{
              flex: 5;
              padding-left: 0.2rem;
              p{
                margin-bottom: 0rem;
                 font-family: SourceHanSansCN-Regular;
                 font-size: 15px;
                 font-weight: normal;
                 font-stretch: normal;
                 line-height: 55px;
                 letter-spacing: 0px;
                 color: #253954;
              }
            }
          }
          .program-overview2{
            flex: 1;
            display: flex;
            box-shadow: 0 0 5px #eaeff5 inset;
            margin-right: 0.5rem;
            padding: 0.3rem;
            margin-bottom: 0.3rem;
            .program-overview-img{
              flex: 1;
              padding-top: 0.3rem;
            }
            .program-overview-word{
              flex: 5;
              padding-left: 0.2rem;
              p{
                margin-bottom: 0rem;
                 font-family: SourceHanSansCN-Regular;
                 font-size: 15px;
                 font-weight: normal;
                 font-stretch: normal;
                 line-height: 55px;
                 letter-spacing: 0px;
                 color: #253954;
                // font-family: SourceHanSansCN-Light;
                // font-size: 11px;
                // font-weight: normal;
                // font-stretch: normal;
                // line-height: 44px;
                // letter-spacing: 0px;
                // color: #253954;
                // margin-bottom: 0rem;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/solution-content/MinimalistSolution.vue